import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { UserApiV2 } from 'ha/services/apiV2/types/User';
import { APIV2_URL } from './constants';

interface AvatarURLPayload {
  avatarUrl: string;
}

export default (makeCall: MakeCall) => (data: AvatarURLPayload) =>
  makeCall<UserApiV2>('POST', `${APIV2_URL}/user/me/avatar-url`, {
    data,
  });
